"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _deviceWarnLog = require("@/api/iot/deviceWarnLog");
var _operate = require("@/api/operate.js");
var _default = {
  name: 'AppMain',
  computed: {
    key: function key() {
      return this.$route.fullPath;
    },
    scrollHeight: function scrollHeight() {
      return this.$refs.appMain.scrollHeight;
    },
    clientHeight: function clientHeight() {
      return this.$refs.appMain.clientHeight;
    }
  },
  data: function data() {
    return {
      fixFooter: false,
      noShadowList: ['goodsIndex', 'goodsAdd', 'shopInfo', 'shopShop', 'billList', 'myFlow', 'myIndex', 'myWithdraw'],
      noPaddingList: ['goodsMeal', 'goodsBaseEdit'],
      noTitleList: ['myWithdraw'],
      audioPlayer: null,
      timer: 0,
      showQos: false,
      qosList: []
    };
  },
  watch: {
    $route: function $route(val) {
      this.fixFooter = false;
    }
  },
  mounted: function mounted() {
    this.init();
    // this.fixFooter = this.scrollHeight > this.clientHeight;
  },
  destroyed: function destroyed() {
    this.stopTimer();
  },
  methods: {
    init: function init() {
      this.audioPlayer = this.$refs.audioPlayer;
      if (this.sMerchantId > 0) {
        this.startTimer();
      }
    },
    handleScroll: function handleScroll(e) {
      var scrollBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
      if (scrollBottom < 80) {
        this.fixFooter = false;
      } else {
        this.fixFooter = true;
      }
    },
    // 检测问题反馈处理记录
    getQosList: function () {
      var _getQosList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var param, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                param = {
                  status: 1,
                  merchant_id: this.sMerchantId
                };
                _context.next = 3;
                return (0, _operate.getQosList)(param).catch(function () {});
              case 3:
                res = _context.sent;
                // console.log('getQosList', res.data)
                if (res) {
                  this.qosList = res.data;
                  this.showQos = res.data.length > 0 && this.$route.name != 'operateQosBack' ? true : false;
                }
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getQosList() {
        return _getQosList2.apply(this, arguments);
      }
      return getQosList;
    }(),
    // 检测报警未处理记录
    chkWarn: function () {
      var _chkWarn2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _deviceWarnLog.chkWarn)().catch(function () {});
              case 2:
                res = _context2.sent;
                // console.log('chkWarn', res)
                if (res && res.data.length > 0) {
                  this.playSound();
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function chkWarn() {
        return _chkWarn2.apply(this, arguments);
      }
      return chkWarn;
    }(),
    playSound: function playSound() {
      if (this.audioPlayer) {
        this.audioPlayer.play();
      }
    },
    closeQos: function closeQos() {
      this.showQos = false;
    },
    goQos: function goQos() {
      this.$router.push({
        name: 'operateQosBack'
      });
      this.showQos = false;
    },
    startTimer: function startTimer() {
      var _this = this;
      if (this.timer == 0) {
        this.timer = setInterval(function () {
          _this.chkWarn();
          _this.getQosList();
        }, 1000 * 10);
      }
    },
    stopTimer: function stopTimer() {
      clearInterval(this.timer);
      this.timer = 0;
    }
  }
};
exports.default = _default;